export function useScreen() {
  return useState('useScreen', () => ({
    xs: false,
    sm: false,
    md: false,
    lg: false,
    xl: true
  }))
}
